module.exports = __webpack_public_path__ + "static/media/GN.b02669f1.svg";